<template>
    <div class="container-fluid" v-if="employee == null">
        <p>{{ error_message }}</p>
    </div>
    <div class="container-fluid" v-if="employee != null">
        <div class="row">
            <div class="col-md-6">
                <h3 class="title">{{ employee.name }}</h3>
            </div>
            <div class="col-md-6"></div>
        </div>
        <br />
        <div class="row">
            <div class="col-xl-12">
                <div class="card" v-bind:class="!employee.is_active ? 'ribbon-wrapper-right' : ''">
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab" id="top-tab" role="tablist" style="display: none">
                            <li class="nav-item"><a @click="tab = 'info'" class="nav-link active" id="info-tab" data-bs-toggle="tab" href="#top-info" role="tab" aria-controls="top-general-tab" aria-selected="true"><i class="icofont icofont-ui-home"></i>Información</a></li>
                            <li class="nav-item"><a @click="tab = 'documents'" class="nav-link" id="docs-tab" data-bs-toggle="tab" href="#top-documents" role="tab" aria-controls="top-wage-tab" aria-selected="false"><i class="icofont icofont-man-in-glasses"></i>Documentación</a></li>
                            <li class="nav-item"><a @click="tab = 'contract'" class="nav-link" id="contracts-tab" data-bs-toggle="tab" href="#top-contract" role="tab" aria-controls="top-contract-tab" aria-selected="false"><i class="icofont icofont-contacts"></i>Contrato de Trabajo</a></li>
                        </ul>
                        <div class="tab-content" id="top-tabContent">
                            <div class="tab-pane fade show active" id="top-info" role="tabpanel" aria-labelledby="top-info-tab">
                                <EmployeeInformationTab ref="informationTab" @refresh="refreshEmployee" />
                            </div>
                            <div class="tab-pane fade" id="top-documents" role="tabpanel" aria-labelledby="top-documents-tab">
                                <EmployeeDocumentsTab ref="documentsTab" @refresh="refreshEmployee" />
                            </div>
                            <div class="tab-pane fade" id="top-contract" role="tabpanel" aria-labelledby="top-contract-tab">
                                <EmployeeContractTab ref="contractTab" @refresh="refreshEmployee" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade disable-employee-modal" @refresh="refreshEmployee" tabindex="-1" role="dialog" aria-labelledby="disableEmployeeModalLabel" aria-hidden="true">
            <DisableEmployeModal :employee="employee" />
        </div>
        <div class="modal fade employee-contract-modal" tabindex="-1" role="dialog" aria-labelledby="contractEmployeeModalLabel" aria-hidden="true">
            <EmployeeContractModal ref="employeeContractModal"/>
        </div>
    </div>
</template>
<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'
import {
    mapState
} from 'vuex';
import DisableEmployeModal from "@/components/tmkt/employees/disable_employee_modal.vue"
import EmployeeContractModal from "@/components/tmkt/employees/employee_contract_modal.vue"
import EmployeeInformationTab from "@/components/tmkt/employees/employee_information_tab.vue"
import EmployeeContractTab from "@/components/tmkt/employees/employee_contracts_tab.vue"
import EmployeeDocumentsTab from "@/components/tmkt/employees/employee_documents_tab.vue"
import validations from "@/mixins/validations/employeeValidations"

import ws from '@/services/employees'
export default {
    name: 'employee_public_view',
    mixins: [validations],
    components: {
        Datepicker,
        DisableEmployeModal,
        EmployeeContractModal,
        EmployeeInformationTab,
        EmployeeContractTab,
        EmployeeDocumentsTab
    },
    data(){
        return{
            token: '',
            error_message: '',
            id: 0,
            employee: null,
            tab: 'info'
        }
    },
    watch: {
        activeTab() {
            const tab_button = document.getElementById(this.activeTab+'-tab');
            tab_button.click();
            this.tab = this.activeTab
        }
    },
    computed: {
        ...mapState({
            activeTab: state => state.public_menu.tab
        }),
    },
    mounted: async function() {
        this.token = await this.$route.params.token;

        let response = await ws.getEmployeeByToken(this.token); 

        if(response.type == "success"){
            this.employee = response.data;
            this.setForm(this.employee);

            await this.$nextTick();

            this.$refs.informationTab.loadEmployee(this.employee);
            this.$refs.documentsTab.loadEmployee(this.employee);
            this.$refs.contractTab.loadEmployee(this.employee, this.token);
        }
        else{
            this.error_message = response.message;
        }
    },
    methods: {
        sendForm(){
            if(this.tab == 'info'){
                this.$refs.informationTab.validations();
            }

            if(this.tab == 'contracts'){
                this.$refs.contractTab.validations();
            }

            if(this.tab == 'docs'){
                this.$refs.documentsTab.validations();
            }
        },
        loadEmployee(employee){
            this.$refs.employeeContractModal.loadEmployee(employee);
        },
        async updateEmployee(form) {
            let response = await ws.updateEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        refreshEmployee(employee){
            this.employee = employee;
            this.setForm(this.employee);
            this.$refs.informationTab.loadEmployee(this.employee);
            this.$refs.contractTab.loadEmployee(this.employee); 
            this.$refs.documentsTab.loadEmployee(this.employee);
        }
    },
}
</script>

<style scoped>
    .container-fluid {
        padding-top: 20px;
    }

    .title{
        font-size: 28px;
    }

    .datepicker-here{
        padding: 0.25rem 0.75rem;
    }

    .rest_days{
        margin-left: 10px;
        float: right;
    }

    .rest_days td{
        padding-right: 8px;
        text-align: center;
    }

    .infonavit td{
        text-align: center;
    }
</style>